import React, { FC, useCallback, useMemo } from "react";
import { useNavigate } from "react-router";
import { BANNER_TYPE, Banner } from "@lookiero/aurora";
import { useI18nMessage } from "@lookiero/i18n-react";
import { useStaticInfo } from "../../hooks/useStaticInfo";
import { DOMAIN, I18nMessages } from "../../i18n/i18n";
import { Routes } from "../../routing/routes";
import { useTrackShopButtonClicked } from "../../tracking/useTrackShopButtonClicked";

interface CategoriesBannerProps {
  readonly scaled: boolean;
}

const CategoriesBanner: FC<CategoriesBannerProps> = ({ scaled }) => {
  const {
    cdnPath,
    session: {
      user: { country, id: userId, segment },
    },
    basePath,
    tradename,
  } = useStaticInfo();
  const navigate = useNavigate();

  const categoriesBannerDescriptionText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.CATEGORIES_BANNER_DESCRIPTION,
  });
  const categoriesBannerTitleText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.CATEGORIES_BANNER_TOP_TITLE,
  });
  const categoriesBannerCtaText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.CATEGORIES_BANNER_CTA,
  });

  const trackShopButtonClicked = useTrackShopButtonClicked({
    country,
    userId,
    segment,
    tradename,
  });
  const handleOnPress = useCallback(() => {
    trackShopButtonClicked({
      buttonId: "banner_fromsalestocat",
    });

    navigate(`${basePath}/${Routes.CATEGORIES}`);
  }, [basePath, navigate, trackShopButtonClicked]);

  const imageBannerUrl = useMemo(() => `${cdnPath}/images/shop/banners/categories/${segment}.webp`, [cdnPath, segment]);

  return (
    <Banner
      description={categoriesBannerDescriptionText}
      image={{ src: imageBannerUrl }}
      scaled={scaled}
      style={!scaled ? { height: "100%" } : null}
      title={categoriesBannerTitleText}
      type={BANNER_TYPE.SQUARED}
      primaryButton={{
        text: categoriesBannerCtaText,
        onPress: handleOnPress,
      }}
    />
  );
};

export { CategoriesBanner };
